export default __webpack_public_path__ + "static/media/Online.6c3e3ef0.png";